import Grid from "@mui/material/Grid2";

import MDBox from "@/components/atoms/MDBox";
import AlertBlock from "@/components/molecules/AlertBlock";
import useGetSalesProductPrice from "@/hooks/requests/sales-product-price/use-get-sales-product-price";
import ISalesProduct from "@/interfaces/sales-product.interfaces";
import { PlanMessages } from "@/messages/plans/plan.messages";

import { getInitialFilterValues, pageNumber, pageSize } from "../../constants";
import { isPlanValid } from "../../form-data";
import PlanCard from "../planCard";

type Props = {
  messages: PlanMessages;
  salesProduct: ISalesProduct;
};

function PricingCards({ messages, salesProduct }: Props) {
  const filters = getInitialFilterValues(salesProduct.id);
  const { data, isLoading, error } = useGetSalesProductPrice({ filters, pageNumber, pageSize });

  // Verificar se data e data.items existem
  const hasPlans = !!data && !!data.items && data.items.length > 0;
  const shouldLoadPlansCard = hasPlans && !isLoading && !error;
  const shouldLoadError = !isLoading && !!error;
  const shouldLoadNoPlans =
    !isLoading && !error && (!data || !data.items || data.items.length === 0);

  return (
    <MDBox position="relative" zIndex={10} mt={8} px={{ xs: 1, sm: 0 }}>
      {shouldLoadPlansCard && data && data.items && (
        <Grid container spacing={3} justifyContent="center" alignItems="stretch">
          {data.items.filter(isPlanValid).map((plan) => (
            <Grid size={{ xs: 12, lg: 4 }} key={plan.id}>
              <PlanCard messages={messages} plan={plan} />
            </Grid>
          ))}
        </Grid>
      )}

      {shouldLoadNoPlans && (
        <AlertBlock
          title={messages.plansNotFoundError}
          description={messages.plansNotFoundDescription}
          alt={messages.plansNotFoundAlt}
        />
      )}

      {!!shouldLoadError && (
        <AlertBlock
          title={messages.errorToLoad}
          description={error?.message || "Erro desconhecido"}
          alt={messages.notFoundAlt}
        />
      )}
    </MDBox>
  );
}

export default PricingCards;
